import ERPSBaseLink from "../components/custom/inputs/ERPSBaseLink";
import { Link } from "../components/primitives";
import { t } from "i18next";
import { listProps, formatDateTime } from "../utils/helper";


export const getAvailableDocumentsHeading = (fileDownload, financialInstitutionMap) => {
  let columns = [
    {
      field: "file_date",
      headerName: t("erps.availabledocuments.label.filedate"),
      width: 120,
      sortable: false,
      renderCell: (params) => formatDateTime(params.value, "YYYY-MM-DD")
    }
  ];

  if (financialInstitutionMap) {
    columns.push({
      field: "fi_number",
      headerName: t("erps.common.label.fi"),
      width: 160,
      sortable: false,
      renderCell: (params) => {
        const fiValue = params.value;
        if (!fiValue || fiValue === 0) return "";
        const translationKey = `erps.availabledocuments.filist.${fiValue}`;
        const translated = t(translationKey);

        if (translated !== translationKey) {
          return translated;
        }
        return financialInstitutionMap?.get(fiValue) || fiValue;
      },
    });
  }

  columns.push(
  {
  field: "file_type",
  headerName: t("erps.availabledocuments.label.source"),
  width: 170,
  sortable: false,
  renderCell: (params) => {
    const key = params.value.toLowerCase().replace(/\s+/g, "");
    return t(`erps.availabledocuments.sourcelist.${key}`);
    },
  }

  ,
  {
    field: "file_number",
    headerName: t("erps.availabledocuments.label.filenumber"),
    width: 145,
    sortable: false,
    renderCell: (params) => (params.value == 0) ? "" : params.value,
  },
  {
    field: "transactions_amount",
    headerName: t("erps.availabledocuments.label.value"),
    width: 120,
    sortable: false,
    align: "right",
    renderCell: (params) => (params.value == "") ? "" : "$ " + Number(params.value).toFixed(2)
  },
  {
    field: "transaction_count",
    headerName: t("erps.availabledocuments.label.numberoftransactions"),
    width: 172,
    sortable: false,
    renderCell: (params) => (params.value == 0) ? "" : params.value,
    //TEMP//renderCell: (params) => ((params.value == 0) ? "" : params.value) + " / " + params.row.file_id
  },
  {
    field: "pdf_link",
    headerName: t("erps.availabledocuments.label.download"),
    width: 125,
    sortable: false,
    renderCell: (params) => {
      const pdfLink = params?.row?.pdf_link;
      const csvLink = params?.row?.csv_link;
      const regExp = /(webportal|document|reports|LegacyReports)/i;
      let pdfWithReportPath = (pdfLink && pdfLink.match(regExp) !== null);
      let csvWithReportPath = (csvLink && csvLink.match(regExp) !== null);

      if (pdfLink || csvLink) {
        return (
          <>
            {pdfWithReportPath && (
              <Link underline="always" component="button"
                    onClick={() => fileDownload(params.row, "PDF")} >
                {t("erps.availabledocuments.label.pdf")}  
              </Link> /* label   "erps.downloadreports.label.pdf" */
            )}
            {(pdfWithReportPath && csvWithReportPath) && (<>&nbsp;&nbsp;</>)}
            {csvWithReportPath && (
              <Link underline="always" component="button"
                    onClick={() => fileDownload(params.row, "CSV")} >
                {t("erps.availabledocuments.label.csv")}
              </Link>
            )}
          </>
        );
      }
    },
  },
  {
    field: "download_by",
    headerName: t("erps.availabledocuments.label.downloadedby"),
    width: 150,
    sortable: false,
  },
  {
    field: "last_download",
    headerName: t("erps.availabledocuments.label.downloadedtime"),
    width: 182,
    sortable: false,
    renderCell: (params) => params.value ? formatDateTime(params.value, "YYYY-MM-DD h:mmA") : t("erps.availabledocuments.label.downloadedtime.new")
  }
  );
  return columns;
};

export const viewRelatedBillerDocuments = (props) => [
  {
    field: "billerIdStr",
    headerName: t("erps.availabledocuments.label.billerid"),
    width: 180,
    sortable: false,
  },
  {
    field: "billerName",
    headerName: t("erps.availabledocuments.label.billername"),
    width: 480,
    sortable: false,
  },
  {
    field: "documents",
    headerName: t("erps.availabledocuments.label.viewdocument"),
    sortable: false,
    width: 180,
    renderCell: (params) => {
      if (props?.pageName === "biller-profile") {
        return (
          <Link underline="always" component="button"
                onClick={() => props?.handleOpenViewDocument({billerId: params.row.billerIdStr, billerType: "child"}) } >
            {t("erps.availabledocuments.label.viewdocument")}
          </Link>
        );
      } else {
        let billerId = params?.row?.billerIdStr;
        let reqBillerId;
        if (typeof billerId === "string") {
          if (billerId.includes("-")) {
            reqBillerId = billerId.split("-")[1];
          } else {
            reqBillerId = billerId;
          }
        }
        return (
          <ERPSBaseLink
            to={{
              pathname: `/downloads-documents/view-documents`,
              state: {
                billerId: reqBillerId,
                billerType: "child",
                searchedBillerId: billerId,
              },
            }}
            className="link__blue"
            label={"F. "+ t("erps.availabledocuments.label.viewdocument")}
          />
        );
      }
    },
  },
];

export const EMPTY_DOCUMENTS_CRITERIA = {
//  fileDate: "",  I think it's not used anywhere [2025-Apr-24]
  startDate: "",
  endDate: "",
  selectedFiNumber: "",
  source: ""
};






